<div
  *ngIf="isLoading"
  class="d-flex flex-col flex-wrap align-items-center justify-content-center"
  style="padding-top: 36px; padding-bottom: 36px"
>
  <mat-progress-spinner mode="indeterminate"></mat-progress-spinner>
  <p>Cargando...</p>
</div>

<mat-dialog-content *ngIf="!isLoading">
  <h3
    style="
      font-weight: 600;
      font-size: 24px;
      line-height: 32px;
      color: #111827;
      text-align: center;
    "
  >
    Replicar Menús de Servicios
  </h3>

  <div
    mat-dialog-content
    style="
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding-top: 16px;
      gap: 24px;
    "
  >
    <div style="flex: 1">
      <p style="font-weight: 500; margin-bottom: 8px">Copiar desde:</p>
      <mat-form-field appearance="outline" style="width: 100%">
        <mat-label>Año Origen</mat-label>
        <mat-select [(ngModel)]="yearOfGroupedServicesToBeCopied">
          <mat-option
            *ngFor="let year of yearsToBeCopied"
            [value]="year"
            [disabled]="year === yearOfGroupedServicesToBeApplied"
          >
            {{ year }}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>

    <div>
      <i-tabler
        name="arrow-right"
        class="icon-20"
        style="color: #6b7280"
      ></i-tabler>
    </div>

    <div style="flex: 1">
      <p style="font-weight: 500; margin-bottom: 8px">Aplicar a:</p>
      <mat-form-field appearance="outline" style="width: 100%">
        <mat-label>Año Destino</mat-label>
        <mat-select [(ngModel)]="yearOfGroupedServicesToBeApplied">
          <mat-option
            *ngFor="let year of yearsToBeApplied"
            [value]="year"
            [disabled]="year === yearOfGroupedServicesToBeCopied"
          >
            {{ year }}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>
  </div>

  <div
    style="
      background-color: #fffbeb;
      border-left: 4px solid #f59e0b;
      padding: 12px;
      margin-top: 16px;
      margin-bottom: 16px;
      border-radius: 4px;
    "
  >
    <p
      style="
        margin: 0;
        font-weight: 500;
        color: #b45309;
        display: flex;
        align-items: center;
        gap: 8px;
      "
    >
      <i-tabler name="alert-triangle" class="icon-20"></i-tabler>
      Advertencia
    </p>
    <p style="margin: 4px 0 0 0; color: #92400e; font-size: 14px">
      Todos los Servicios que NO contengan menus, serán alterados, aquellos que
      ya tengan, no se modificarán.
    </p>
  </div>

  <mat-dialog-actions align="center">
    <button mat-button mat-dialog-close>Cancelar</button>
    <button
      mat-raised-button
      style="background-color: #e95a1a; color: white"
      (click)="updateAllServices()"
      [disabled]="
        !yearOfGroupedServicesToBeCopied || !yearOfGroupedServicesToBeApplied
      "
    >
      Replicar Menús
    </button>
  </mat-dialog-actions>
</mat-dialog-content>
